import React from 'react';
import { ProsAndCons as ProsAndConsComponent } from '@components/bilguide/ProsAndCons';
import { ProsAndCons } from '@appTypes/carModelType';
import * as S from './ProsAndConsSerializer.styles';

interface ProsAndConsSerializerProps {
  value: ProsAndCons;
}

export const ProsAndConsBlock: React.FC<ProsAndConsSerializerProps> = ({ value }) => {
  if (!value) return null;

  const { pros, cons } = value;

  return (
    <S.StyledProsAndConsBlock>
      <ProsAndConsComponent pros={pros} cons={cons} />
    </S.StyledProsAndConsBlock>
  );
};
